import { withViewModel } from '../../../infrastructure/components/with-view-model';
import OEPassportAttendeeSSOFormPresentation from './oe-passport-attendee-sso-form.presentation';
import PassportAttendeeSSOFormVM from './oe-passport-attendee-sso-form.viewmodel';

interface IProps {
    vm: PassportAttendeeSSOFormVM;
}

const OEPassportAttendeeSSOFormContainer = withViewModel(
    OEPassportAttendeeSSOFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { OEPassportAttendeeSSOFormContainer as OEPassportAttendeeSSOForm };
